<template>
  <div>
    <ModalCover @closeModal="closeModal" :show_close="false">
      <!-- MODAL BODY -->
      <div slot="modal-cover-body">
        <transition name="fade" mode="out-in">
          <components
            :is="in_view"
            @startup-proctor="switchProctorView"
            :tag="tag"
            @close="closeModal"
            @start-exam="startExam"
          ></components>
        </transition>
      </div>
    </ModalCover>
  </div>
</template>

<script>
import { EXTERNAL_URL } from "@/var";
import ModalCover from "@/components/globalComps/ModalCover";
import { mapGetters, mapActions } from "vuex";
import { randomString } from "@/scripts/utilities";

export default {
  name: "StartExamModal",

  props: {
    exam_id: Number,
    tag: String,
    proctor: Number,
  },

  components: {
    ModalCover,
    StartupIntro: () =>
      import(
        /* webpackChunkName: "StartupIntro" */ "@/components/parentsComps/proctorSetup/StartupIntro"
      ),
    ProctorCheckup: () =>
      import(
        /* webpackChunkName: "ProctorCheckup" */
        "@/components/parentsComps/proctorSetup/ProctorCheckup"
      ),
  },

  computed: {
    ...mapGetters(["getSelectedChildID"]),
  },

  data() {
    return {
      in_view: "StartupIntro",
      account_type: "",
      route_name: "",
    };
  },

  methods: {
    ...mapActions(["setAssessmentId"]),

    switchProctorView() {
      this.in_view = "ProctorCheckup";
    },

    closeModal() {
      this.$emit("closeTriggered");
    },

    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];

      if (this.account_type === "parent")
        this.route_name = "ParentHomeworkTest";
      else if (this.account_type === "student")
        this.route_name = "StudentHomeworkTest";
    },

    generateId(id) {
      return `${randomString(11)}${id}`;
    },

    startExam() {
      this.getAccountType();
      this.setAssessmentId(this.exam_id); //SETUP ASSESSMENT ID IN STATE
      localStorage.setItem("tag", this.tag);
      localStorage.setItem("setup_checker", this.proctor);

      // REDIRECT TO LMS
      location.href = EXTERNAL_URL("test", `/assessment/${this.exam_id}`);

      // this.$router.replace({
      //   name: this.route_name,
      //   query: {
      //     id: this.generateId(this.exam_id),
      //   },
      // });
    },
  },
};
</script>
